
  <div class="filter-container">
    <form [formGroup]="byAssignedForm">
      <div formArrayName="assignedUsers">
        <div
          class="sgc"
          *ngFor="let assignedCtrl of assignedUsers.controls; let i = index"
        >
          <single-choice
            [formControl]="assignedCtrl"
            (click)="setEditingIndex(i)"
            [completedUrl]="completionUrl"
            [topic]="'users'"
            [editMode]="true"
            [ticketId]="fakeId"
            [icon]="'person'"
            (choiceEvent)="relaySingleChoice($event)"
            [labelOnDemand]="assignedLabelerByService"
            [choiceObserver]="assignedObserver"
          ></single-choice>
        </div>
      </div>

      <button
        type="button"
        class="add-assigned-btn"
        (click)="addAssignedField()"
      >
        +
      </button>

      <not
        [filter]="byAssignedFilter"
        (filterChanged)="onFilterChanged($event)"
      >
      </not>

      <button class="apply-filter-btn" type="submit" (click)="apply()">
        Apply
      </button>
    </form>
  </div>

